(()=>{
  'use strict';
  const config=document.querySelector('[data-diennet-intake]');
  const pendingKey='diennet.assessment.pending.v1';
  const state={get:k=>{try{return JSON.parse(sessionStorage.getItem(k)||'null')}catch{return null}},set:(k,v)=>{try{sessionStorage.setItem(k,JSON.stringify(v))}catch{}}};
  function send(name,params={}){
    if(window.Shopify?.theme?.role!=='main'||window.Shopify?.designMode)return;
    if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
    if(typeof window.gtag==='function')window.gtag('event',name,params);
  }
  function confirmAssessment(){
    const pending=state.get(pendingKey);
    if(!pending||Date.now()-pending.at>900000)return;
    try{if(!pending.formId||localStorage.getItem(pending.formId+'-dismissed-after-submit')!==pending.formId)return}catch{return}
    state.set(pendingKey,null);
    send('assessment_submission_success',{form_id:'new_patient_assessment'});
  }
  if(location.pathname.endsWith('/pages/assessment-next-step'))confirmAssessment();
  const practical=document.getElementById('DiennetPracticalEnquiry');
  if(practical){
    practical.addEventListener('submit',()=>{if(practical.checkValidity())state.set('diennet.general.pending',Date.now())});
    if(practical.querySelector('[data-diennet-enquiry-success]')){
      const at=state.get('diennet.general.pending');
      if(at&&Date.now()-at<900000){state.set('diennet.general.pending',null);send('generate_lead',{form_id:'DiennetPracticalEnquiry',lead_type:'programme_question'})}
      practical.closest('details')?.setAttribute('open','');
    }
  }
  if(!config)return;
  const initialized=new WeakSet(),observed=new WeakSet();
  function enhance(form){
    if(initialized.has(form)||form.id==='DiennetPracticalEnquiry')return;
    if(document.querySelector('[data-dn-questionnaire]')&&form.getRootNode()?.host?.closest?.('[data-forms-id="forms-root-668661"]')){
      initialized.add(form);
      form.addEventListener('submit',()=>{state.set(pendingKey,{at:Date.now(),formId:'668661'})},true);
      return;
    }
    const candidates=[...form.querySelectorAll('[class*="_formFieldContainer_"]')];
    const containers=candidates.filter(e=>!candidates.some(parent=>parent!==e&&parent.contains(e)));
    if(containers.length<9)return;
    initialized.add(form);
    const fallback=config.querySelector('[data-assessment-fallback]');if(fallback)fallback.hidden=true;
    const perPage=6,count=Math.ceil(containers.length/perPage);
    let step=0,all=false;
    const root=form.getRootNode();
    const style=document.createElement('style');
    style.textContent='.dn-intake-hidden{display:none!important}.dn-intake-nav{margin:18px 0;padding:16px;background:#f7f3ea;border:1px solid #dfd8cc;border-radius:8px;color:#123b36;font:16px/1.5 Arial,sans-serif}.dn-intake-nav button{padding:10px 15px;border:1px solid #123b36;border-radius:5px;margin:6px 8px 0 0;background:#123b36;color:#fff;font:inherit;cursor:pointer}.dn-intake-nav button:focus-visible{outline:3px solid #aa8b30;outline-offset:3px}.dn-intake-nav button:disabled{opacity:.5;cursor:default}.dn-intake-progress{display:block;margin-bottom:8px;font-weight:600}.dn-intake-nav .dn-intake-all{background:white;color:#123b36}';
    (root instanceof ShadowRoot?root:document.head).append(style);
    const nav=document.createElement('nav');nav.className='dn-intake-nav';nav.setAttribute('aria-label',config.dataset.progress);
    const progress=document.createElement('span');progress.className='dn-intake-progress';progress.setAttribute('aria-live','polite');
    const back=document.createElement('button'),next=document.createElement('button'),toggle=document.createElement('button');
    [back,next,toggle].forEach(b=>b.type='button');back.textContent=config.dataset.back;next.textContent=config.dataset.next;toggle.className='dn-intake-all';
    nav.append(progress,back,next,toggle);form.before(nav);
    const bottom=nav.cloneNode(false);const bottomBack=back.cloneNode(true),bottomNext=next.cloneNode(true);bottom.append(bottomBack,bottomNext);form.after(bottom);
    const submitButtons=[...form.querySelectorAll('button[type="submit"],button[class*="_formSubmitButton_"]')];
    function display(focus=false){
      containers.forEach((e,i)=>e.classList.toggle('dn-intake-hidden',!all&&Math.floor(i/perPage)!==step));
      submitButtons.forEach(e=>e.classList.toggle('dn-intake-hidden',!all&&step<count-1));
      progress.textContent=all?config.dataset.all:config.dataset.part+' '+(step+1)+' '+config.dataset.of+' '+count;
      [back,bottomBack].forEach(e=>e.disabled=step===0||all);[next,bottomNext].forEach(e=>e.hidden=all||step===count-1);
      toggle.textContent=all?config.dataset.paged:config.dataset.all;
      if(focus){nav.scrollIntoView({block:'start',behavior:'smooth'});const field=containers[step*perPage]?.querySelector('input:not([type="hidden"]),textarea,select');field?.focus({preventScroll:true})}
    }
    function move(delta){
      if(delta>0){const invalid=containers.slice(step*perPage,(step+1)*perPage).flatMap(e=>[...e.querySelectorAll('input,select,textarea')]).find(e=>e.willValidate&&!e.checkValidity());if(invalid){invalid.reportValidity();return}}
      step=Math.max(0,Math.min(count-1,step+delta));display(true);
    }
    back.addEventListener('click',()=>move(-1));bottomBack.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));bottomNext.addEventListener('click',()=>move(1));toggle.addEventListener('click',()=>{all=!all;display()});
    form.addEventListener('invalid',event=>{const i=containers.findIndex(e=>e.contains(event.target));if(i>=0){step=Math.floor(i/perPage);display()}},true);
    form.addEventListener('submit',()=>{all=true;display();const formId=form.getRootNode()?.host?.closest?.('[data-forms-id]')?.dataset.formsId?.replace(/^forms-root-/,'')||'668661';state.set(pendingKey,{at:Date.now(),formId});send('assessment_submit_attempt',{form_id:'new_patient_assessment'})},true);
    display();
  }
  function inspect(root){
    root.querySelectorAll('form').forEach(enhance);
    root.querySelectorAll('shopify-forms-embed').forEach(host=>{if(host.shadowRoot)watch(host.shadowRoot)});
    confirmAssessment();
  }
  const queued=new WeakSet();
  function watch(root){
    if(observed.has(root))return;observed.add(root);inspect(root);
    new MutationObserver(()=>{if(queued.has(root))return;queued.add(root);queueMicrotask(()=>{queued.delete(root);inspect(root)})}).observe(root,{childList:true,subtree:true});
  }
  watch(document);
  let tries=0;const timer=setInterval(()=>{inspect(document);if(++tries>=30)clearInterval(timer)},1000);
})();
